<template>
  <AntButton
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </AntButton>
</template>

<script>
import { Button as AntButton } from 'ant-design-vue';

export default {
  name: 'Button',
  components: { AntButton },
};
</script>

<style lang="scss" scoped>
  .ant-btn {
    /* TODO: add font */
    /* font-family: SFProText; */
    background-color: $accent;
    border-radius: 12px;
    border: 0;
    color: $white;
    font-size: 15px;
    font-weight: 600;
    height: 60px;
    letter-spacing: .19px;
    margin: 0 40px;
  }
</style>
